



















































































































import { Vue, Component } from "vue-property-decorator";
import {
  getActivityTypeListApi,
  addActivityTypeApi,
  editActivityTypeApi,
  delActivityTypeApi,
} from "@/api/marketActivity";
import { dateFormat } from "@/utils/timeFormat";

@Component({
  name: "activitytype",
})
export default class extends Vue {
  searchInfo: any = {};
  page: number = 1;
  pageSize: number = 10;
  pageSizeArray: number[] = [5, 10, 30, 50, 100];
  total: number = 0;
  tableData: any[] = [];
  activityTypeDialog: boolean = false;
  activityTypeData: any = {};
  activityTypeRules: any = {
    title: [
      {
        required: true,
        message: "活动类型不能为空",
        trigger: "blur",
      },
    ],
  };
  created() {
    this.getList();
  }
  solveSearchInfo(option: any) {
    let params = { ...option };
    if (this.searchInfo.type) {
      params.type = this.searchInfo.type;
    }
    if (this.searchInfo.title) {
      params.title = this.searchInfo.title;
    }
    return params;
  }
  getList(params?: any) {
    let option = this.solveSearchInfo(params);
    getActivityTypeListApi(option).then((res: any) => {
      if (res.error_code === 0) {
        res.data.list.forEach((item: any) => {
          item.create_time = dateFormat(
            "YYYY-mm-dd HH:MM",
            item.create_time * 1000
          );
        });
        this.tableData = res.data.list;
        this.total = res.data.total;
      }
    });
  }
  handleSearch() {
    this.getList({
      page: 1,
      page_size: this.pageSize,
    });
  }
  // 新增
  handleAdd() {
    this.activityTypeData = {
      title: "",
      sort: "",
    };
    this.activityTypeDialog = true;
  }
  // 编辑
  handleEdit(scope: any) {
    this.activityTypeData = {
      type_id: scope.row.type_id,
      title: scope.row.title,
      sort: scope.row.sort || 0,
    };
    this.activityTypeDialog = true;
  }
  hideActivityTypeDialog() {
    this.activityTypeDialog = false;
  }
  // 提交
  handleSubmit() {
    if (this.activityTypeData.type_id) {
      if (!this.activityTypeData.sort) this.activityTypeData.sort = 0;
      editActivityTypeApi(this.activityTypeData).then((res: any) => {
        if (res.error_code === 0) {
          this.$message({
            message: "编辑成功",
            type: "success",
          });
          this.getList();
          this.hideActivityTypeDialog();
        } else {
          return this.$message({
            message: res.message,
            type: "error",
          });
        }
      });
    } else {
      if (!this.activityTypeData.sort) this.activityTypeData.sort = 0;
      addActivityTypeApi(this.activityTypeData).then((res: any) => {
        if (res.error_code === 0) {
          this.$message({
            message: "新增成功",
            type: "success",
          });
          this.getList();
          this.hideActivityTypeDialog();
        } else {
          return this.$message({
            message: res.message,
            type: "error",
          });
        }
      });
    }
  }
  // 删除
  handleDel(scope: any) {
    this.$confirm(
      `确定对${scope.row.title}的活动类型进行删除么？`,
      `删除-${scope.row.title}`,
      {
        confirmButtonText: "确定",
        confirmButtonClass: "mwow-button-filled success mini",
        cancelButtonText: "取消",
        cancelButtonClass: "mwow-button-filled mini",
        iconClass: "mwow-icon-error",
      }
    )
      .then(() => {
        delActivityTypeApi({
          type_id: scope.row.type_id,
        }).then((res: any) => {
          if (res.error_code === 0) {
            this.$message({
              message: "删除成功",
              type: "success",
            });
            this.getList();
          } else {
            this.$message({
              message: res.message,
              type: "error",
            });
          }
        });
      })
      .catch(() => {});
  }
  handlePagerChange(e: number) {
    this.getList({
      page: e,
      page_size: this.pageSize,
    });
  }
  handlePagerSizeChange(e: number) {
    this.pageSize = e;
    this.getList({
      page: 1,
      page_size: e,
    });
  }
}
